var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSingleChoice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "#38393C",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.75243 3.6001C4.75243 4.15238 4.28663 4.6001 3.71205 4.6001C3.13749 4.6001 2.67169 4.15238 2.67169 3.6001C2.67169 3.04782 3.13749 2.6001 3.71205 2.6001C4.28663 2.6001 4.75243 3.04782 4.75243 3.6001Z",
    strokeWidth: 0
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.71202 1.6C2.51344 1.6 1.598 2.5259 1.598 3.6C1.598 4.6741 2.51344 5.6 3.71202 5.6C4.91062 5.6 5.82606 4.6741 5.82606 3.6C5.82606 2.5259 4.91062 1.6 3.71202 1.6ZM0 3.6C0 1.5813 1.69298 0 3.71202 0C5.73108 0 7.42406 1.5813 7.42406 3.6C7.42406 5.6187 5.73108 7.2 3.71202 7.2C1.69298 7.2 0 5.6187 0 3.6Z",
    strokeWidth: 0
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.71202 10.3998C2.51344 10.3998 1.598 11.3257 1.598 12.3998C1.598 13.4739 2.51344 14.3998 3.71202 14.3998C4.91062 14.3998 5.82606 13.4739 5.82606 12.3998C5.82606 11.3257 4.91062 10.3998 3.71202 10.3998ZM0 12.3998C0 10.3811 1.69298 8.7998 3.71202 8.7998C5.73108 8.7998 7.42406 10.3811 7.42406 12.3998C7.42406 14.4185 5.73108 15.9998 3.71202 15.9998C1.69298 15.9998 0 14.4185 0 12.3998Z",
    strokeWidth: 0
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.73907 3.5998C8.73907 3.15798 9.05368 2.7998 9.44175 2.7998H15.2973C15.6854 2.7998 16 3.15798 16 3.5998C16 4.04162 15.6854 4.3998 15.2973 4.3998H9.44175C9.05368 4.3998 8.73907 4.04162 8.73907 3.5998Z",
    strokeWidth: 0
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.73907 12.4001C8.73907 11.9583 9.05368 11.6001 9.44175 11.6001H15.2973C15.6854 11.6001 16 11.9583 16 12.4001C16 12.8419 15.6854 13.2001 15.2973 13.2001H9.44175C9.05368 13.2001 8.73907 12.8419 8.73907 12.4001Z",
    strokeWidth: 0
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSingleChoice);
export default __webpack_public_path__ + "static/media/single-choice.0d654ac748ef05d03e170b905c058bf2.svg";
export { ForwardRef as ReactComponent };